import { useState } from "react";
import { BorrowersList } from "./components/BorrowersList";
import { CreditorOverview } from "./components/CreditorOverview";
import { EmiDashboard } from "./components/EmiDashboard";
import { InvestorsList } from "./components/InvestorsList";

type CreditorView = "overview" | "investors" | "emi-dashboard" | "borrowers";

export function CreditorPage() {
  const [view, setView] = useState<CreditorView>("overview");

  return (
    <div className="p-4 sm:p-6">
      {view === "overview" && (
        <CreditorOverview
          onViewInvestors={() => setView("investors")}
          onViewEmiDashboard={() => setView("emi-dashboard")}
          onViewBorrowers={() => setView("borrowers")}
        />
      )}
      {view === "investors" && <InvestorsList onBack={() => setView("overview")} />}
      {view === "emi-dashboard" && <EmiDashboard onBack={() => setView("overview")} />}
      {view === "borrowers" && <BorrowersList onBack={() => setView("overview")} />}
    </div>
  );
}
